import { ChartComponent } from '..'
import { AxisPosition } from '../components/AxisComponent.vue'
import { Ticks } from './ticks'

export type FormatterType = 'string' | 'date'

export type Formatter = {
  type: FormatterType
  format: string
}

export type Axis<Position extends AxisPosition = AxisPosition> = {
  position?: Position
  showTicks?: boolean
  showLine?: boolean
  lines?: boolean
}

const lines = (
  ticks: number[],
  limits: [number, number],
  horizontal: boolean
): ChartComponent<'line'>[] =>
  ticks.map(
    (tick): ChartComponent<'line'> => ({
      type: 'line',
      stroke: '#E0E0E0',
      strokeWidth: 1.0,
      dashArray: [4, 4],
      xLimits: horizontal ? limits : [0, 1],
      yLimits: horizontal ? [0, 1] : limits,
      values: horizontal
        ? [
            [tick, 0],
            [tick, 1]
          ]
        : [
            [0, tick],
            [1, tick]
          ]
    })
  )

export function createAxis(
  axis: Axis,
  ticks: Ticks<'complete'>,
  limits: [number, number]
): ChartComponent[] {
  const tickValues = ticks.values
  const tickLabels = ticks.labels

  if (
    (tickLabels && tickValues.length !== tickLabels.length) ||
    (tickLabels && tickValues.length !== tickLabels.length)
  ) {
    throw new Error('Number of tick labels must match number of ticks')
  }

  const horizontal = axis.position === 'bottom' || axis.position === 'top'

  return tickValues.length > 0
    ? [
        {
          type: 'axis',
          position: axis.position ?? 'bottom',
          ticks: tickValues,
          tickLabels: tickLabels,
          domain: limits,
          showTicks: axis.showTicks,
          showLine: axis.showLine,
          rotate: ticks.rotate
        },
        ...(axis.lines ? lines(tickValues, limits, horizontal) : [])
      ]
    : []
}
